import { useGLTF, RoundedBox } from "@react-three/drei";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import { useMemo } from "react";
import { COLORS } from "../../constants/colors";
import TreeShadow from "./TreeShadow.jsx";
import { MODELS } from "../loader/models.js";

const TreeAllColor = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const tree = useGLTF(MODELS.TREE_ALL_COLOR);

  // Клонируем сцену для каждого экземпляра
  const clonedScene = useMemo(() => {
    return tree.scene.clone();
  }, [tree.scene]);

  return (
    <group position={position} rotation={rotation}>
      <TreeShadow size={3} opacity={0.4} softness={0.8} />
      <primitive scale={0.6} position-y={-0.6} object={clonedScene} />
      <RigidBody type="fixed" ccd={false}>
        <CuboidCollider args={[0.4, 0.25, 0.4]} />
        <RoundedBox args={[0.8, 0.3, 0.8]} radius={0.1} position-y={-1}>
          <meshStandardMaterial color={COLORS.wood} />
        </RoundedBox>
      </RigidBody>
    </group>
  );
};

export default TreeAllColor;
